import React from 'react';
import Avatar from '@mui/material/Avatar';
import { DEFAULT_THEME_COLOR } from '../../constants/theme';

export default function FreaksAvatar({ username, imageUrl, size = 40 }) {
  return (
    <Avatar
      alt={username}
      src={imageUrl || undefined}
      sx={{ width: size, height: size, flexShrink: 0, bgcolor: DEFAULT_THEME_COLOR, fontSize: size * 0.45 }}
    >
      {(username || '?').slice(0, 1).toUpperCase()}
    </Avatar>
  );
}
